//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.TemplateConfigItem

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The template config wrapper. Contains a list of configs (history, current, preview).
* 
* @param configItems The template configurations.
* @param organizerName The organizer name
* @param templateId The template id. Never changes, even if preview switches to current.The configId of history, current and preview is de facto also a template id,used for the event preview. Under the hood, we switch the mapping oftemplateId <-> current.configId and preview.configId, if the user savesand publishes the preview.
*/
@Serializable

data class TemplateConfig (


      /* The template configurations. */
    @SerialName(value = "configItems") @Required val configItems: kotlin.collections.Set<TemplateConfigItem>,


      /* The organizer name */
    @SerialName(value = "organizerName") @Required val organizerName: kotlin.String,


      /* The template id. Never changes, even if preview switches to current.The configId of history, current and preview is de facto also a template id,used for the event preview. Under the hood, we switch the mapping oftemplateId <-> current.configId and preview.configId, if the user savesand publishes the preview. */
    @SerialName(value = "templateId") val templateId: kotlin.uuid.Uuid? = null


) {




  }

